import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/utils/query-keys';
import { Risk } from '@/components/views/Resolution886/enums';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';

interface UseUpdateResolution886CategoryResultParams {
	organization_id: string;
	company_id: string;
	assessment_id: string;
	category_result_id: string;
	category_key: string;
	category_result_risk: Risk;
	category_result_observation?: string | null;
}

const Service = Resolution886ReportService.getInstance();

export function useUpdateResolution886CategoryResult() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UseUpdateResolution886CategoryResultParams) => Service.updateCategoryResult(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_CATEGORY]);
			queryClient.invalidateQueries([QUERY_KEYS.UPDATE_RESOLUTION_886_CATEGORY_RESULT]);
		},
		onError: () => {
			message.error(I18n.get('Error updating category result'));
		}
	});
}
